export const Login = import('./Login.vue')
export const Register = import('./Register.vue')
export const UserTypeSylector = import('./UserTypeSylector.vue')
export const ChangePassword = import('./ChangePassword.vue')
export const ForgotPassword = import('./ForgotPassword.vue')
export const ResetPassword = import('./ResetPassword.vue')


